// @ts-nocheck
import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import { useFormikContext } from 'formik'
import { partition, pluck, uniq } from 'ramda'
import { useAllRequirements } from '../../hooks'
import { BulkTraitSetter } from './BulkTraitSetter'
import { DetailTemplateField } from './DetailTemplateField'

export const YearlyDetailsTable = () => {
  const theme = useTheme()
  const requirements = useAllRequirements()
  const { values, setValues } = useFormikContext()

  if (requirements.isLoading) {
    return null
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [yearlyRequirements, yearlessRequirements] = partition(d => !!d.year, requirements.data)
  const yearlyTraits = uniq(pluck('traitId', yearlyRequirements))
  const years = uniq(pluck('year', yearlyRequirements)).sort()

  const clearTrait = (traitId: string) => {
    const newValues = {}

    Object.keys(values).forEach(name => {
      if (name.split('-')[0] !== traitId) {
        newValues[name] = values[name]
      } else {
        newValues[name] = null
      }
    })

    setValues(newValues)
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          size="small"
          sx={{
            minWidth: 650,
            '& td.MuiTableCell-sizeSmall': { padding: 0 },
            '& th': { padding: 1 },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Trait</TableCell>
              {years.map(year => (
                <TableCell key={year} align="center">
                  {year}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {yearlyTraits.map(traitId => (
              <TableRow key={traitId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ backgroundColor: theme.palette.ciboSensed }}
                >
                  <Stack direction="row" justifyContent="space-between">
                    <Typography variant="h5">{traitId}</Typography>
                    <Button onClick={() => clearTrait(traitId)} startIcon={<CloseIcon />}>
                      clear row
                    </Button>
                  </Stack>
                  <BulkTraitSetter traitId={traitId} />
                </TableCell>

                {years.map(year => {
                  if (
                    yearlyRequirements.find(req => req.traitId === traitId && req.year === year)
                  ) {
                    return (
                      <TableCell key={year} align="right">
                        <DetailTemplateField traitId={traitId} year={year} />
                      </TableCell>
                    )
                  } else {
                    return <TableCell key={year} align="right"></TableCell>
                  }
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
